import React from 'react';
import { useHistory, useLocation } from 'react-router';
import * as MUI from '@material-ui/core';
import { createStyles } from "@material-ui/styles";
import { Theme, makeStyles } from "@material-ui/core";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import cn from 'classnames';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginRight: theme.spacing(1),
      "&:hover": {
        color: theme.palette.primary.main,
      },
    },
  }));

type BackButtonProps = {
    backToPath?: string;
    className?: string;
    size?: "medium" | "small";
};

const BackButton: React.FunctionComponent<BackButtonProps> = (props) => {
    const {backToPath, size = "small"} = props;
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();

    const getParentPath = (): string => {
      let breadCrumbs = location.pathname.split("/");
      breadCrumbs.pop();
      const parentPath = breadCrumbs.join('/');
      return parentPath ? parentPath : '/';
    };
    const canGoBack = (): boolean => {
      return (window as any).navigationHistory && (window as any).navigationHistory.length > 0;
    };
    const handleGoBackClick = () => {
      if (backToPath) {
        history.push(backToPath);
      } else if (canGoBack()) {
        history.goBack();
      } else {
        history.replace(getParentPath());
      }
    };
    return (
        <MUI.Tooltip title={"Back"}>
          <MUI.IconButton 
            size={size} 
            className={cn(classes.root, props.className)} 
            onClick={handleGoBackClick}
        >
            <ArrowBackIcon />
          </MUI.IconButton>
        </MUI.Tooltip>
    )
};
export default BackButton;